// node_modules
import { StrictMode } from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
// Components
import App from "./App";
// CSS
import "./index.css";
// Stores
import { AuthStore } from "./Stores";
import { Toaster } from "react-hot-toast";

// To use the store and access its main state from anywhere in our application 
// we need to wrap it around our main App component. 
// This way, all the children of the App component 
// will have access to the store and its values.
ReactDOM.render(
  <StrictMode>
    <AuthStore>
      <App />
      <Toaster position="top-right" reverseOrder={false} />
    </AuthStore>
  </StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
